import { Button, Checkbox, Divider, Empty, Form, Radio, Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { SDrawerOrModal, SSkuCard } from 'shj-components'
export default function SkuDynamic(props) {
  const { formList, onSubmit, loading } = props
  const [list, setList] = useState([])
  const [form] = Form.useForm()
  const [btnLoading, setBtnLoading] = useState(false)
  // 初始化
  useEffect(() => {
    formList.map(item => {
      form.setFieldsValue({
        [item.id]: item.optionId || undefined,
      })
    })
    setList(formList)
  }, [formList])

  const { open, title } = props
  const onSubmitModal = async () => {
    setBtnLoading(true)
    try {
      await onSubmit(list)
      setBtnLoading(false)
    } catch (error) {
      setBtnLoading(false)
    }
    props.onCancel()
  }

  const onChange = (item, value, index) => {
    let newList: any = [...list]
    if (value) {
      item.skuDynamicOptionVos.map(option => {
        if (option.id === value) {
          item.optionId = option.id
          item.optionName = option.name
        }
      })
    } else {
      newList[index].optionId = undefined
      newList[index].optionName = ''
    }
    newList[index] = item
    setList(newList)
  }

  return (
    <SDrawerOrModal
      mode="modal"
      open={open}
      onCancel={() => props.onCancel()}
      title={title}
      width={600}
      antdProps={{
        footer: (
          <>
            <Button key="back" onClick={() => props.onCancel()}>
              取消
            </Button>
            <Button key="submit" type="primary" loading={btnLoading} onClick={onSubmitModal}>
              确定
            </Button>
          </>
        ),
        getContainer: false,
        wrapClassName: 'sku-dynamic-modal',
      }}
    >
      <div style={{ height: '100%' }}>
        {/* <Spin spinning={loading}> */}
        {open && (
          <Form
            form={form}
            labelCol={{ xs: { span: 24 }, sm: { span: 24 } }}
            style={{ height: '100%' }}
          >
            {list.map((item: any, index) => {
              return (
                <Form.Item
                  label={item.name}
                  name={item.id}
                  key={item.id}
                  labelCol={{ span:24, offset: 24 }}
                >
                  <Select
                    onChange={value => onChange(item, value, index)}
                    allowClear
                    placeholder="请选择"
                  >
                    {item.skuDynamicOptionVos?.map((option, optionIndex) => {
                      return <Select.Option value={option.id}>{option.name}</Select.Option>
                    })}
                  </Select>
                </Form.Item>
              )
            })}
          </Form>
        )}
        {/* </Spin> */}
      </div>
    </SDrawerOrModal>
  )
}
